/* eslint-disable jsx-a11y/label-has-for */
import { Component } from 'react';

import { Button, CustomSelect, TextInput } from '@ce-cfbdigital/cgl-cfb-fe-foundation';
import { Formik } from 'formik';
import PropTypes from 'prop-types';
import * as Yup from 'yup';

import { logger } from '../../../common/logger';
import { isMobileDevice } from '../../../common/utilities';
import { BZ_UNIT, CUSTOMER, EMAIL, PORTAL } from '../../constants';

class UserManagementEditInfo extends Component {
  constructor(props) {
    super(props);
    this.initialValue = {};
    this.validationObj = {};
    props.fields.forEach(field => {
      const currentData = props.data[field.apiKey];
      if (field.type === 'inputBox') {
        this.initialValue[field.apiKey] = currentData;
        if (field.required) {
          this.validationObj[field.apiKey] = Yup.string().required(field.error);
        }
      } else {
        if (field.required) {
          if (field.apiKey === BZ_UNIT) {
            this.validationObj[field.apiKey] = Yup.array().required(field.error);
          } else {
            this.validationObj[field.apiKey] = Yup.object().required(field.error);
          }
        }
        if (field.apiKey === BZ_UNIT) {
          this.initialValue[field.apiKey] = currentData.filter(o => o.selected);
        } else {
          this.initialValue[field.apiKey] = currentData.find(o => o.selected);
        }
      }
    });

    const userType = props.data.userType.find(f => f.selected);
    this.userType = userType ? userType.value : CUSTOMER;
    const source = props.data.contractSource.find(f => f.selected);
    this.source = source ? source.value : PORTAL;

    const country = props.data?.country.find(f => f.selected);

    this.state = {
      languageOptions: country ? this.setLanguages(country) : []
    };
  }

  onSubmit = values => {
    const { handleFormSubmit } = this.props;
    handleFormSubmit(values);
  };

  getValues = (values, apiKey) => (values[apiKey] ? values[apiKey].value : '');

  isDisabled = field => {
    try {
      const {
        rules,
        userObj: { email }
      } = this.props;

      if (!rules || !rules[field]) {
        return false;
      }

      const userRules = rules[field][this.userType]?.[this.source];

      if (!userRules) {
        throw new Error(`No rules found for field: ${field}, userType: ${this.userType}, source: ${this.source}`);
      }

      if (field === EMAIL && (email || ['LEAP', 'OKTA'].includes(this.source))) {
        return true;
      }

      return userRules.disabled;
    } catch (error) {
      logger.error('Error in isDisabled function:', error.message);
      return false;
    }
  };

  createValidationSchema = () => Yup.object().shape(this.validationObj);

  setLanguages = key => {
    const {
      data: { language: rowLanguageData }
    } = this.props;
    const keyValue = key.value.toLowerCase();

    return rowLanguageData.filter(lang => {
      const langLable = lang.label.toLowerCase();
      const langValue = lang.value.toLowerCase();
      if (keyValue === 'br') {
        return langLable === 'english' || langValue.includes(keyValue) || langValue.includes('es');
      }

      return langLable === 'english' || langValue.includes(keyValue);
    });
  };

  onChangeHandler = (key, value, setFieldValue = () => {}) => {
    if (key === 'country') {
      setFieldValue('language', '', false);
      this.setState({ isCountryChange: true, languageOptions: this.setLanguages(value) });
    } else if (key === 'language') {
      this.setState({ isCountryChange: false });
    }
    setFieldValue(key, value, false);
  };

  setSelectDropdownValue = (item, values) => {
    const { isCountryChange } = this.state;
    if (item.apiKey === 'language' && isCountryChange) {
      return '';
    }
    return values[item.apiKey];
  };

  render() {
    const { fields, data, labels, handleCancel, editOnly } = this.props;
    const { languageOptions } = this.state;
    const conditionalClasses = isMobileDevice() ? 'epsilon' : 'delta';
    return (
      <div className="basic-info-wrapper">
        <Formik
          initialValues={this.initialValue}
          validationSchema={this.createValidationSchema()}
          onSubmit={values => this.onSubmit(values)}
        >
          {({ values, errors, handleSubmit, setFieldValue }) => (
            <>
              {fields.map(item => {
                const errorClass = errors[item.apiKey] ? 'error' : '';
                if (item.type === 'inputBox') {
                  return (
                    <div key={item.apiKey} className="form-group">
                      <label htmlFor={item.apiKey} className="eta">
                        {item.label}
                      </label>
                      {this.isDisabled(item.apiKey) ? (
                        <p className={conditionalClasses}>{values[item.apiKey]}</p>
                      ) : (
                        <TextInput
                          id={item.apiKey}
                          ariaLabel={item.label}
                          classes="form-input-wrap"
                          type="text"
                          value={values[item.apiKey]}
                          inputClassName={`input-field ${errorClass}`}
                          onChange={e => setFieldValue(item.apiKey, e.target.value, false)}
                        />
                      )}
                      {errors[item.apiKey] && <p className="error-msg">{errors[item.apiKey]}</p>}
                    </div>
                  );
                }
                if (item.type === 'selectBox') {
                  const multiSelect = item.apiKey === BZ_UNIT;
                  return (
                    <div key={item.apiKey} className="form-group">
                      <label htmlFor={item.apiKey} className="eta">
                        {item.label}
                      </label>
                      {this.isDisabled(item.apiKey) ? (
                        <p className={conditionalClasses}>{this.getValues(values, item.apiKey)}</p>
                      ) : (
                        <CustomSelect
                          id={item.apiKey}
                          name={item.apiKey}
                          isMulti={multiSelect}
                          withCheckBox={multiSelect}
                          ariaLabel={item.label}
                          classNamePrefix="sub-dropdown"
                          value={this.setSelectDropdownValue(item, values)}
                          classes={`${errorClass}`}
                          options={item.apiKey === 'language' ? languageOptions : data[item.apiKey]}
                          onChange={value => {
                            this.onChangeHandler(item.apiKey, value, setFieldValue);
                          }}
                          placeholder={item.placeholderText}
                        />
                      )}
                      {errors[item.apiKey] && <p className="error-msg">{errors[item.apiKey]}</p>}
                    </div>
                  );
                }
                return null;
              })}

              <div className="action-container">
                {editOnly && (
                  <Button
                    buttonLabel={labels.cancel}
                    classes="btn btn-light"
                    type="submit"
                    handleClick={handleCancel}
                  />
                )}
                <Button buttonLabel={labels.save} classes="btn btn-color" type="button" handleClick={handleSubmit} />
              </div>
            </>
          )}
        </Formik>
      </div>
    );
  }
}

UserManagementEditInfo.propTypes = {
  fields: PropTypes.arrayOf({}).isRequired,
  data: PropTypes.arrayOf({}).isRequired,
  handleFormSubmit: PropTypes.func.isRequired,
  handleCancel: PropTypes.func.isRequired,
  labels: PropTypes.instanceOf(Object).isRequired,
  rules: PropTypes.instanceOf(Object).isRequired,
  editOnly: PropTypes.bool.isRequired,
  userObj: PropTypes.instanceOf(Object).isRequired
};

export default UserManagementEditInfo;
